
import { Loader, LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { VerifyLinkSent } from '@/components/toast-messages';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { useVerifyAccountRequest } from '@/services/auth/mutations';

interface ThankYouSectionProps {
  email: string;
}

export const ThankYouSection = ({ email }: ThankYouSectionProps) => {
  const { toast } = useToast();

  const { mutate, isPending } = useVerifyAccountRequest({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: 'Email Sent',
        description: <VerifyLinkSent email={email} />,
      });
    },
    onError: (error) => {
      const { title, message } = error.getErrorMessage({
        title: 'Uh oh! Something went wrong.',
        message:
          'There was a problem sending your verification email. Please try again.',
      });
      toast({
        variant: 'destructive',
        title,
        description: Array.isArray(message) ? message.join(' ') : message,
      });
    },
  });

  return (
    <div className="flex flex-col space-y-4">
      <Button
        disabled={isPending}
        className="w-full"
        type="button"
        onClick={() => mutate({ email })}
      >
        {isPending ? (
          <Loader className="mr-2 h-4 w-4 animate-spin" />
        ) : (
          <LogIn className="mr-2 h-4 w-4" />
        )}
        Resend verification link
      </Button>
      <Button asChild variant="outline">
        <Link to="/dashboard">Take me to the dashboard</Link>
      </Button>
    </div>
  );
};
